// Generic double-click → LiveView event bridge (LiveView has no phx-dblclick).
// Usage: phx-hook="DblClick" data-event="my_event"
export default {
  mounted() {
    this.handler = () => this.pushEvent(this.el.dataset.event || "dblclick", {});
    this.el.addEventListener("dblclick", this.handler);
  },
  destroyed() {
    this.el.removeEventListener("dblclick", this.handler);
  },
};
